<template>
    <section class="vehicle-details">
        <div class="vehicle-details-content">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <h1>{{ vehicleDetailsPageHeading }}</h1>
                        <h3 class="make"><span>{{order.vehicle.manufacturerName}}</span> {{ order.vehicle.modelName }}</h3>
                        <p class="model">{{order.vehicle.derivativeName}}</p>
<!--                        <p class="registration">Registration</p>-->

                        <h4>Details</h4>

                        <div>
                            <span class="key">
                                P11d Value:
                            </span>
                            <span class="value">
                                <strong>£{{ order.quote.details.pricing.p11DValue.toLocaleString() }}</strong>
                            </span>
                        </div>
                        <div>
                            <span class="key">
                                C0<sup>2</sup>:
                            </span>
                            <span class="value">
                                <strong>{{ order.derivative?.primaryTechnicalItems?.primaryTechnicalItems?.cO2?.technicalItemValue }}</strong>
                            </span>
                        </div>

                    </div>
                    <div class="col-sm-6">
                        <vehicle-image :derivative="order.derivative" :showMain="true"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="vehicle-details-equipment">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2>Selected vehicle equipment</h2>

                        <vehicle-specification :quote="order.quote" :derivative="order.derivative"/>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
import VehicleImage from "../vehicle-details/vehicle-image";
import VehicleSpecification from "../vehicle-details/vehicle-specification";
export default {
    name: "vehicle-details",
    components: {VehicleSpecification, VehicleImage},
    props: ['order','product'],
    computed: {
        vehicleDetailsPageHeading() {
            return this.product?.vehicle_details_page_heading ? this.product.vehicle_details_page_heading : '';
        }
    }
}
</script>

<style scoped>
.vehicle-details-content {
    background: #fff;
    padding:4rem 0;
}
.vehicle-details-equipment {
    padding:4rem 0;
    background-color: whitesmoke;
}
</style>
